import React from 'react';
import ReactQRCode from 'qrcode.react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';

const QRCode = ({ link }) => (
  <Box minWidth="100%" justifyContent="center" paddingTop="big" paddingBottom="big">
    <ReactQRCode
      value={link}
      size={256}
      renderAs="svg"
    />
  </Box>
);

QRCode.propTypes = {
  link: PropTypes.string.isRequired,
};

export default QRCode;
